import { z } from 'zod';
import isMobilePhone from 'validator/lib/isMobilePhone';

const createRefinedSchema = (predicate, message, t) =>
  z
    .string({
      message: t('auth.required_field'),
    })
    .refine(predicate, { message });

const validatePhoneNumber = (val) => {
  const phoneNumber = val.replace(/[()+-]/g, '');
  return isMobilePhone(phoneNumber);
};

export const PhoneSchema = (t) =>
  z.object({
    phone: createRefinedSchema(
      validatePhoneNumber,
      t('auth.login.phone.error_invalid'),
      t
    ),
  });

export const EmailSchema = (t) =>
  z.object({
    email: z
      .string({
        message: t('auth.required_field'),
      })
      .email(t('auth.login.email.error_invalid')),
  });

export const VerificationSchema = (t) =>
  z
    .object({
      email: z.string().email(t('auth.login.email.error_invalid')).optional(),
      phone: z
        .string()
        .refine((val) => !val || validatePhoneNumber(val), {
          message: t('auth.login.phone.error_invalid'),
        })
        .optional(),
    })
    .refine((data) => data.email || data.phone, {
      message: t('account_verification.at_least_one_required'),
      path: ['email'],
    });

export const SmsConfirmSchema = z.string().length(1);
